<template>
    <el-card class="temp-item">
        <div class="temp-item-head">
            <template v-if="!isEditName">
                {{ data.name }} <i class="pl8 el-icon-edit-outline edit-icon" @click="handleEditName"/> 
            </template>
            <template v-else>
                <el-input 
                    v-model="inputData"
                    ref="inputRef"
                    :disabled="data.loading"
                    autofocus 
                    placeholder="请输入模板名称" 
                    :maxlength="35" 
                    clearable
                    @blur="handleBlur"
                    style="width: 300px"
                />
            </template>
        </div>
        <div class="temp-item-body mt10 mb10">
            <div class="ellipsis ">
                <span class="pr10 font14px text-color-gray text-bold">筛选条件:</span>
                <el-popover
                    placement="top-start"
                    title="筛选条件"
                    width="300"
                    trigger="hover">
                    <span>{{condition_config}}</span>
                    <span slot="reference">{{condition_config}}</span>
                </el-popover>
            </div>
            <div class="ellipsis ">
                <span class="pr10 font14px text-color-gray text-bold">维度分组:</span>
                <el-popover
                    placement="top-start"
                    title="维度分组"
                    width="300"
                    trigger="hover">
                    <span>{{ dimension_text }}</span>
                    <span slot="reference">{{ dimension_text }}</span>
                </el-popover>
            </div>
            <div class="ellipsis ">
                <span class="pr10 font14px text-color-gray text-bold">数据指标:</span>
                <el-popover
                    placement="top-start"
                    title="数据指标"
                    width="300"
                    trigger="hover">
                    <span>{{ field_config }}</span>
                    <span slot="reference">{{field_config}}</span>
                </el-popover>
            </div>
        </div>
        <div class="temp-item-footer">
            <div class="left"><el-button v-matomo="{behaviorCategory: '素材查询分析', name: '模板(应用模板)' }" type="primary" size="large" @click="()=>$emit('use-temp', data)" :disabled="data.loading">应用模板</el-button></div>
            <div class="right">
                <el-checkbox v-matomo="{behaviorCategory: '素材查询分析', name: '模板(默认展示)' }" :value="is_default" :disabled="data.loading" @change="()=>$emit('default-temp', data)">默认展示</el-checkbox>
                <el-button type="primary" @click="()=>$emit('top-temp', data)" class="ml20 mr20" size="mini" :plain="is_top" :disabled="data.loading">
                    {{ is_top?'取消置顶': '置顶'}}
                </el-button>
                <el-popconfirm
                    title="这是一段内容确定删除吗？"
                    @confirm="()=>$emit('del-temp', data)"
                    :disabled="data.loading"
                >
                    <el-button 
                        slot="reference" 
                        :disabled="data.loading" 
                        type="danger" size="mini" 
                        plain 
                    >
                        删除模版
                    </el-button>
                </el-popconfirm>
                
            </div>
        </div>
    </el-card>
</template>

<script>
export default {
    props: [ 'data', 'util' ],
    data() {
        return {
            isEditName: false,
            inputData: ''
        }
    },
    computed: {
        is_default() {
            return !!+this.data.is_default
        },
        is_top() {
            return !!+this.data.is_top
        },
        condition_config() {
            const text = this.data.condition_config.map(v=>{
                let str = v.display_name;
                // console.log(this.util, v);
                
                // if (v.modalData) {
                //     const sub_text = this.util.getConditionSubText(v);
                //     str += `(${sub_text})`;
                // }
                return str
            }).join('、')
            return text || '未设置';
        },
        field_config() {
            return this.data.field_config.map(v=>v.display_name).join('、') || '未设置';
        },
        dimension_text() {
            const text = this.data.dimension_config.map(v=>{
                let str = v.display_name;
                 if (v.modalData && (v.modalData.order_by || v.modalData.dimension) ) {
                    const sub_text = this.util.getDimensionSubText(v);
                    str += `(${sub_text})`;
                };
                return str;
            }).join('、');
            return text || '未设置';
        }
    },
    methods: {
        handleEditName() {
            this.inputData = this.data.name;
            this.isEditName = true;
            this.$nextTick(()=>this.$refs.inputRef.focus())
        },
        async handleBlur() {
            if (!this.inputData) {
                this.$message.error('模板名称不能为空');
                this.inputData = this.data.name;
                this.$refs.inputRef.focus();
                return
            };
            this.$emit('updata-name', this.inputData, { ...this.data }, ()=>{
                this.isEditName = false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.temp-item {
    margin-bottom: 10px;
    &-head {
        font-weight: bold;
        .edit-icon{
            color: #66b1ff;
            font-size: 16px;
        }
    }
    &-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}
</style>